import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, watch, computed, onBeforeUnmount } from 'vue';

interface OptionData {
  label: string;
  value: string | number | boolean | object;
}

interface SelectData {
  selectedValue: string | number | boolean | object;
  optionArray: OptionData[];
  onOptionCreated: (optionData: OptionData) => void;
  onOptionDestroyed: (value: string | number | boolean | object) => void;
  onOptionSelected: (optionData: OptionData) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Option',
  props: {
    label: null,
    value: { type: [String, Number, Boolean, Object] }
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  value: string | number | boolean | object;
};

const optionRef = ref(null);


const select: SelectData | undefined = inject('select');

const isSelected = computed(
  () => select && select.selectedValue === props.value
);

const optionData = computed(() => ({
  label: props.label,
  value: props.value,
  ref: optionRef,
}));

select?.onOptionCreated(optionData.value);

onBeforeUnmount(() => {
  select?.onOptionDestroyed(props.value);
});

watch(
  () => [props.value, props.label],
  (val, oldVal) => {
    if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
      select?.onOptionDestroyed(oldVal);
      select?.onOptionCreated(optionData.value);
    }
  }
);

function handleChooseOption() {
  select?.onOptionSelected(optionData.value);
}

return { __sfc: true,optionRef, props, select, isSelected, optionData, handleChooseOption }
}

})